import './image.scss'

export const renderImage = (
    { url, image_alt_text, image, quick_view_plp = {} },
    theme = 'portrait'
) => {
    if (!image) {
        return ''
    }

    let img = `<nb-img file="${image}"
        description="${image_alt_text}"
        aspect_ratio="${theme === 'portrait' ? '16/9' : '1/1'}"
        object_fit="contain"
        force_height="${theme === 'portrait' ? '160' : '120'}">
    </nb-img>`

    const renderClass = url ? '' : 'class="cursor-default"'

    if (url || quick_view_plp?.show_view) {
        const linkHref = url || 'javascript:void(0)'
        img = `<a ${renderClass.trim()} href="${linkHref}" target="_self" aria-hidden="true" tabindex="-1">${img}</a>`
    }

    return `<div class="cb-image">
                ${img}
            </div>`
}
